/** @format */
import { AxiosResponse } from 'axios';

export const isAxiosResponse = (response: any): response is AxiosResponse =>
    Boolean(response.data);
